<template>
    <div class="sales-card-nav" :class="{'scrollEvent' : !isVisisbleOnScrollEvent, 'initBGvisible' : isHeaderBGonScrollEvent}">
        <div class="container">
            <div class="inner-content">
                <div class="left-column">
                    <div class="project-name">
                        <a href="#" v-scroll-to="{el: '#app', offset: 0}">
                            <h1>{{ salesCardArr.project_name.name }}</h1>
                        </a>
                        <div class="btn-open-mobile-menu" v-if="isMobileChecker" @click="openMobileMenu = !openMobileMenu" :class="{'open' : openMobileMenu}">
                            <svgIcon name="arrow-down" class="icon-arrow-down"/>
                        </div>
                    </div>
                    <div class="sales-card-navigation-list" :class="{'open' : openMobileMenu}">
                        <ul>
                            <li>
                                <a href="#"  v-scroll-to="{el: '#sales-card-prems-section',offset: -100}" class="parent-link">{{ salesCardArr.project_page_in.nav_prems_name }}</a>
                            </li>
                            <li v-if="salesCardArr.project_page_in.location_menu.init">
                                <a href="#"  v-scroll-to="{el: '#sales-card-location-section',offset: -100}" class="parent-link">{{ salesCardArr.project_page_in.location_menu.name }}</a>
                            </li>
                            <li v-if="salesCardArr.project_page_in.exclusive_menu.init">
                                <a href="#"  v-scroll-to="{el: '#sales-card-exclusive-section',offset: -100}" class="parent-link">{{ salesCardArr.project_page_in.exclusive_menu.name }}</a>
                            </li>
                            <li v-if="salesCardArr.project_page_in.news_menu.init">
                                <a href="#"  v-scroll-to="{el: '#sales-card-news-section',offset: -100}" class="parent-link">{{ salesCardArr.project_page_in.news_menu.name }}</a>
                            </li>
                            <li class="dropdown-item" v-if="salesCardArr.project_page_in.present != null && salesCardArr.project_page_in.present.menu != ''">
                                <span @click.prevent="setCurrentIndex(1)">{{ salesCardArr.project_page_in.present.menu }}</span>
                                <svgIcon name="arrow-down" class="icon-arrow-down"/>
                                <div class="dropdown-list">
                                    <ul>
                                        <li v-for="item in salesCardArr.project_page_in.present.links"><a :href="item.file" target="_blank">{{ item.name }}</a></li>
                                    </ul>
                                </div>
                                <slide-up-down :active="currentIndex == 1" :duration="400" class="dropdown-menu-mobile" v-if="isMobileChecker">
                                    <ul>
                                        <li v-for="item in salesCardArr.project_page_in.present.links"><a :href="item.file" target="_blank">{{ item.name }}</a></li>
                                    </ul>
                                </slide-up-down>
                            </li>
                            <li class="dropdown-item video-item" v-if="salesCardArr.project_page_in.video_header != null && salesCardArr.project_page_in.video_header.menu != ''">
                                <span @click.prevent="setCurrentIndex(2)">{{ salesCardArr.project_page_in.video_header.menu }}</span>
                                <svgIcon name="arrow-down" class="icon-arrow-down"/>
                                <div class="dropdown-list">
                                    <ul>
                                        <li v-for="item in salesCardArr.project_page_in.video_header.links"><a :href="item.link" target="_blank" @click.prevent="openVideoModal(item)">{{ item.name }}</a></li>
                                    </ul>
                                </div>
                                <slide-up-down :active="currentIndex == 2" :duration="400" class="dropdown-menu-mobile" v-if="isMobileChecker">
                                    <ul>
                                        <li v-for="item in salesCardArr.project_page_in.video_header.links"><a :href="item.link" target="_blank" @click.prevent="openVideoModal(item)">{{ item.name }}</a></li>
                                    </ul>
                                </slide-up-down>
                            </li>
                            <li v-if="salesCardArr.project_page_in.present_file != null && salesCardArr.project_page_in.present_file.fail != false">
                                <a :href="salesCardArr.project_page_in.present_file.fail"  target="_blank">{{ salesCardArr.project_page_in.present_file.name }}</a>
                            </li>
                            <li v-if="isMobileChecker" class="mobile-link-to-flats">
                                <router-link class="link-to-flats-nav parent-link" to="/flats">
                                    <span>{{ salesCardArr.project_page_in.setup_flats_btn }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="btns-go-items">
                    <div class="btn-go-item btn-go-to-flats-nav">
                        <router-link class="link-to-flats" to="/flats">{{salesCardArr.project_page_in.setup_flats_btn}}</router-link>
                    </div>
                    <div class="btn-go-item btn-consult" @click="openContactsFormModal('call-page-get', cardID, 'Шапка с навигацией')">
                        <span v-if="globalLang != 'kz/'">Оставить заявку</span>
                        <span v-else>Өтінім қалдыру</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SlideUpDown from 'vue-slide-up-down'
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-nav',
        props: ['salesCardArr'],
        components: {
            svgIcon,
            SlideUpDown,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                globalLang: window.GlobalLang, 
                openMobileMenu: false,
                currentIndex: null,
            }
        },
        computed: mapGetters({
            isVisisbleOnScrollEvent: 'loadIsVisibleScrollEvent',
            isHeaderBGonScrollEvent: 'loadIsHeaderBGscrollEvent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
            setCurrentIndex(index) {
                if (this.currentIndex == index) {
                    this.currentIndex = null;
                } else {
                    this.currentIndex = index
                }
            },
            openVideoModal(data) {
                this.$store.commit('setSalesCardVideoModalData', data);
                this.$store.commit('setOpenSalesCardVideoModal', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('visibilityHide');
                document.getElementById('footer').classList.add('visibilityHide');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-nav.scss';
    @import '@/styles/components/sales-card/respond/sales-card-nav-respond.scss';
    // @import '@/styles/components/home-page/respond/home-actions-respond.scss';
    // @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>